import { render, staticRenderFns } from "./ContentCounters.vue?vue&type=template&id=77b7a9f4&scoped=true&"
import script from "./ContentCounters.vue?vue&type=script&lang=js&"
export * from "./ContentCounters.vue?vue&type=script&lang=js&"
import style0 from "./ContentCounters.vue?vue&type=style&index=0&id=77b7a9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b7a9f4",
  null
  
)

export default component.exports